import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseMiscDomainService } from '@common/domain/base-misc-domain.service';
import { PersonalDataService } from '@common/services/personal-data.service';

import { AlertMiscApiService } from '../api/alert-misc-api.service';
import { AlertApi } from '../api/models';
import { Alert } from './models/alert';
//import { TypedAction } from '@ngrx/store/src/models';
import { arrayMapper } from '@common/operators';

@Injectable({
    providedIn: 'root'
})
export class AlertMiscDomainService extends BaseMiscDomainService
{
    constructor (
        private alertMiscApiService: AlertMiscApiService,
        private personalDataService: PersonalDataService
    )
    {
        super();
    }

    getAlerts (): Observable<Alert[]>
    {
        return this.alertMiscApiService.getAlerts()
            .pipe(
                arrayMapper(Alert.mapperFromApi)
            );
    }

    getActiveAlerts (): Observable<Alert[]>
    {
        const readAlerts: string[] = this.personalDataService.getReadAlerts();

        return this.alertMiscApiService.getActiveAlerts()
            .pipe(
                map((alerts: AlertApi[]): Alert[] =>
                    alerts
                        ? alerts
                            .filter((alert: AlertApi): boolean =>
                                !readAlerts.includes(alert.id)
                            )
                            .map((item: AlertApi): Alert =>
                                Alert.mapperFromApi(item)
                            )
                        : null
                )
            );
    }

    createAlert (alert: Alert): Observable<Alert>
    {
        return this.alertMiscApiService.createAlert(alert)
            .pipe(
                map(Alert.mapperFromApi)
            );
    }

    updateAlert(alert: Alert): Observable<Alert>
    {
        return this.alertMiscApiService.updateAlert(alert)
            .pipe(
                map(Alert.mapperFromApi)
            );
    }

    disableAlert (alertId: string): Observable<void>
    {
        return this.alertMiscApiService.disableAlert(alertId);
    }

    activateAlert (alertId: string): Observable<void>
    {
        return this.alertMiscApiService.activateAlert(alertId);
    }

    deleteAlert (alertId: string): Observable<void>
    {
        return this.alertMiscApiService.deleteAlert(alertId);
    }
}
